import { render, staticRenderFns } from "./DialogMediosEstatales.vue?vue&type=template&id=06974402&scoped=true"
import script from "./DialogMediosEstatales.vue?vue&type=script&lang=js"
export * from "./DialogMediosEstatales.vue?vue&type=script&lang=js"
import style0 from "./DialogMediosEstatales.vue?vue&type=style&index=0&id=06974402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06974402",
  null
  
)

export default component.exports